export default __webpack_public_path__ + "static/media/button.2a5ff0ab.png";